import { ProductEntry, SubscriptionInfoContainer } from '../../../store/api';
import {
    ManageRenewalCells,
    SimpleManageRenewalCells,
    SimpleRenewalTile,
    SimpleRenewalUsageLimit
} from '../utils/renewalTableTileTypes';
import { formatUsageLimit } from '../../../shared/utils/formatUsageLimit';
import { UpdateLineItemsParams } from '../../../api/subscription-management/renewals/updateRenewalLine';
import { mapNextYearRenewalLine } from './mapNextYearRenewalLine';
import { mapIssueUsageIndividual } from '../../../shared/subscription-management/mappings/mapIssueUsage';
import { mapProductTitleWarningSymbol } from '../../../shared/subscription-management/mappings/mapProductTitleWarningSymbol';
import { getPatronSubscriptionsLabel } from '../../../shared/subscription-management/utils/getPatronSubscriptionsLabel';
import { issueNotDeliveredYet } from '../../../shared/subscription-management/types/IssueUsage';
import { TFunction } from 'i18next';

export const mapSimpleRenewalBody = (
    renewalEntries: ProductEntry[],
    spocCurrency: string,
    updateRenewalLine: (params: UpdateLineItemsParams) => void,
    t: TFunction
): SimpleManageRenewalCells => {
    const list: SimpleRenewalTile[] = renewalEntries.map(entry => {
        const { currentSubscriptions, previousIssueStatistics, currentIssueStatistics, patronSubscriptions } = entry;

        return {
            product: entry.product,

            userSubscribedLabel: getPatronSubscriptionsLabel(patronSubscriptions, t),
            showWarning: mapProductTitleWarningSymbol({
                previousLoanStatistics: previousIssueStatistics?.individual,
                currentLoanStatistics: currentIssueStatistics?.individual
            }),

            currentYearSubscriptions:
                currentSubscriptions && currentSubscriptions.individualUsageLimit != null
                    ? {
                          type: SimpleRenewalUsageLimit.Value,
                          label: formatUsageLimit(t, currentSubscriptions.individualUsageLimit),
                          stockDetails: currentSubscriptions.stockDetails.overview
                      }
                    : {
                          type: SimpleRenewalUsageLimit.None,
                          label: t('shop.subscriptions.noCurrentYearSubscription')
                      },

            previousIssueUsage: hasSubscription(currentSubscriptions)
                ? previousIssueStatistics.individual
                    ? mapIssueUsageIndividual(previousIssueStatistics.individual)
                    : issueNotDeliveredYet(t)
                : undefined,

            currentIssueUsage: hasSubscription(currentSubscriptions)
                ? currentIssueStatistics.individual
                    ? mapIssueUsageIndividual(currentIssueStatistics.individual)
                    : issueNotDeliveredYet(t)
                : undefined,

            nextYearRenewalLine: mapNextYearRenewalLine(entry, spocCurrency, updateRenewalLine, t)
        };
    });

    return {
        type: ManageRenewalCells.Simple,
        list
    };
};

const hasSubscription = (currentYearSubscription?: SubscriptionInfoContainer) =>
    currentYearSubscription?.individualUsageLimit != null;
